/* eslint-disable react/destructuring-assignment */
import React, { ReactNode, useState } from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Typography, TypographyProps } from '@mui/material';

export type CopyableFieldProps = TypographyProps & {
  value: string | number | any;
  label?: string | ReactNode;
  tooltip?: string;
};

export default function CopyableField(props: CopyableFieldProps) {
  const [copied, setCopied] = useState(false);
  const { value, label, className, children, tooltip, ...rest } = props;

  return (
    <Typography component="span" className={className} {...rest}>
      {label ?? value}
      {children}
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          navigator.clipboard
            .writeText(value)
            .then(() => {
              setCopied(true);
              setTimeout(() => {
                setCopied(false);
              }, 2000);
            })
            .catch((error) => console.warn('Could not write to the clipboard', error));
        }}
        size="small"
        title={tooltip ?? 'Copy ' + (label ?? value)}
        aria-label={tooltip ?? 'Copy ' + (label ?? value)}
      >
        {copied ? <CheckCircleIcon /> : <ContentCopyIcon />}
      </IconButton>
    </Typography>
  );
}
